import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface userState {
  data: [] | null | any;
  totalPage: number | null;
  currentPage: number | null;
  totalRecords: number | null;
}

const initialState: userState = {
  data: null,
  totalPage: null,
  currentPage: null,
  totalRecords: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.data = action.payload.data;
      state.totalPage = action.payload.totalPage;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewUser: (state: any, action) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUser, reset, addNewUser } = userSlice.actions;
export const getUserDetails = (state: RootState) => state.user.data;
export const getUserTotalRecords = (state: RootState) => state.user.totalRecords;



export default userSlice.reducer;
